const GALLERY = 'gallery';
const YODA = 'yoda';
const CARTRIDGE = 'cartridge';
const ONE_RECORD_BANNER = 'oneRecordBanner';
const PRODUCT_SEARCH = 'productSearch';

export const cardTypes = {
    LIST: 'list',
    GRID: 'grid',
};

export const cardThemes = {
    CARTRIDGE,
    GALLERY,
    YODA,
    ONE_RECORD_BANNER,
    PRODUCT_SEARCH,
};

export const ratingSizes = {
    [GALLERY]: 15,
    [YODA]: 15,
    [CARTRIDGE]: 20,
    [ONE_RECORD_BANNER]: 15,
    [PRODUCT_SEARCH]: 15,
};

export const LAZY_LOAD_SCROLL_OFFSET = {
    8: 500,
    12: 1000,
    16: 1500,
};
